import { MergeTagBlot } from './MergeTagBlot';
import { prettyToTagMap, tagToPrettyMap } from '../MergeTagOptions';

export const MERGE_TAG_REGEX = /\{\{[a-zA-Z0-9_.]+\}\}/g;

export const mergeTagQuillParser = () => {
  const parse = (html?: string): string => {
    if (!html) return '';

    return html.replace(MERGE_TAG_REGEX, tag => {
      const prettyTag = tagToPrettyMap.get(tag) ?? tag;
      const node = MergeTagBlot.create(prettyTag);
      return node.outerHTML;
    });
  };

  const serialize = (html?: string) => {
    if (!html) return '';

    const container = document.createElement('div');
    container.innerHTML = html;

    container.querySelectorAll('span.merge-tag').forEach(element => {
      if (element.tagName !== 'SPAN') return;
      const span = element as HTMLSpanElement;
      const pretty = span.dataset.tag ?? '';

      const tag = prettyToTagMap.get(pretty);
      if (!tag) return;
      span.replaceWith(document.createTextNode(tag));
    });

    return container.innerHTML;
  };

  return { parse, serialize };
};
